if (!customElements.get('footer-accordion')) {
  customElements.define(
    'footer-accordion',
    class FooterAccordion extends HTMLElement {
      constructor() {
        super();
        this.isMobile = () => window.innerWidth <= 989;
      }

      connectedCallback() {
        const headings = this.querySelectorAll('.footer-block__heading--toggle');
        
        headings.forEach((heading) => {
          heading.addEventListener('click', () => {
            if (this.isMobile()) {
              this.toggleMenu(heading);
            }
          });
        });

        // Handle window resize
        this.handleResize = () => {
          if (!this.isMobile()) {
            // Reset all menus on desktop
            headings.forEach((heading) => {
              const menuList = heading.nextElementSibling;
              if (menuList) {
                menuList.style.maxHeight = null;
                heading.classList.remove('is-expanded');
                heading.setAttribute('aria-expanded', 'false');
              }
            });
          }
        };

        window.addEventListener('resize', this.handleResize);
      }

      toggleMenu(heading) {
        if (!this.isMobile()) return;
        
        const menuList = heading.nextElementSibling;
        if (!menuList) return;
        
        const isExpanded = heading.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
          heading.setAttribute('aria-expanded', 'false');
          menuList.style.maxHeight = null;
          heading.classList.remove('is-expanded');
        } else {
          // Close other open menus
          const allHeadings = this.querySelectorAll('.footer-block__heading--toggle');
          allHeadings.forEach((h) => {
            if (h !== heading) {
              h.setAttribute('aria-expanded', 'false');
              const otherMenuList = h.nextElementSibling;
              if (otherMenuList) {
                otherMenuList.style.maxHeight = null;
              }
              h.classList.remove('is-expanded');
            }
          });
          
          heading.setAttribute('aria-expanded', 'true');
          menuList.style.maxHeight = menuList.scrollHeight + 'px';
          heading.classList.add('is-expanded');
        }
      }

      disconnectedCallback() {
        if (this.handleResize) {
          window.removeEventListener('resize', this.handleResize);
        }
      }
    }
  );
}
